export { Qa } from "./qa";
